import * as React from "react";
import styled from "styled-components";

import { Button, SimpleLoader } from "../../../../components/atoms";
import { TooltipPopoverContainer } from "../../../../containers/common/tooltip-popover";
import { SearchAddressContainer } from "../../../../containers/search/search-address";
import { SearchCategoryContainer } from "../../../../containers/search/search-category";
import { SearchDateContainer } from "../../../../containers/search/search-date";
import { SearchTimeContainer } from "../../../../containers/search/search-time";
import { ICategory } from "../../../../services/api/category-list";
import { SearchInputField } from "../../../../containers/search/search-form-treatments";
import * as analytics from "../../../../analytics";

interface IProps {
  category: ICategory;
  isCategoryPreselected: boolean;
  isHideDateTimeBooking: boolean;
  isShowTooltip: boolean;
  isTherapistsLoading: boolean;
  tooltipText: string;
  onInputClick(justclose?: boolean): void;
  onSelect(): void;
  onSubmit(e: React.FormEvent<HTMLFormElement>): void;
  trackEvent(
    field: SearchInputField,
    analyticsEvent: analytics.AnalyticsEvents,
    value?: string | undefined,
  ): void;
}

const SearchForm = styled.form`
  position: relative;

  > *:not(:first-child) {
    margin-top: 10px;
  }

  > *:last-child {
    margin-top: 0;
  }
`;

const SearchFormTreatmentsDateTimeWrapper = styled.div``;

const SearchFormTreatmentsButton = styled(Button)`
  width: 100%;
  padding: 11px 15px;
  margin-top: 14px;
`;

const SearchFormTreatmentsTooltipWrapper = styled.div`
  padding-top: 10px;

  > div {
    width: 100%;
  }
`;

const SearchFormTreatments: React.FC<IProps> = ({
  category,
  isCategoryPreselected,
  isHideDateTimeBooking,
  isShowTooltip,
  isTherapistsLoading,
  tooltipText,
  onInputClick,
  onSelect,
  onSubmit,
  trackEvent,
}) => {
  const handleTrackChange = (
    field: SearchInputField,
    value: string | undefined,
  ) => {
    trackEvent(field, analytics.AnalyticsEvents.SEARCH_WIDGET_CHANGED, value);
  };

  return (
    <SearchForm onSubmit={onSubmit}>
      {!isCategoryPreselected && (
        <SearchCategoryContainer
          onClick={() => {
            onInputClick(true);
            trackEvent(
              "Category",
              analytics.AnalyticsEvents.SEARCH_WIDGET_FOCUSED,
            );
          }}
          trackChange={(value: string | undefined) =>
            handleTrackChange("Category", value)
          }
        />
      )}
      <SearchAddressContainer
        onSelect={onSelect}
        onClick={() => {
          onInputClick(true);
          trackEvent(
            "Address",
            analytics.AnalyticsEvents.SEARCH_WIDGET_FOCUSED,
          );
        }}
        trackChange={(value: string | undefined) =>
          handleTrackChange("Address", value?.toUpperCase())
        }
      />
      {!isHideDateTimeBooking && (
        <React.Fragment>
          <SearchFormTreatmentsDateTimeWrapper>
            <SearchDateContainer
              isCategoryPreselected={isCategoryPreselected}
              category={category}
              onClick={onInputClick}
              trackFocus={() =>
                trackEvent(
                  "Date",
                  analytics.AnalyticsEvents.SEARCH_WIDGET_FOCUSED,
                )
              }
              trackChange={(value: string | undefined) =>
                handleTrackChange("Date", value)
              }
              isShowTooltip={isShowTooltip}
            />
            <SearchTimeContainer
              onClick={(justclose: boolean) => {
                onInputClick(justclose);
                trackEvent(
                  "Time",
                  analytics.AnalyticsEvents.SEARCH_WIDGET_FOCUSED,
                );
              }}
              trackChange={(value: string | undefined) =>
                handleTrackChange("Time", value)
              }
            />
          </SearchFormTreatmentsDateTimeWrapper>
          <SearchFormTreatmentsButton type="submit" background="blue">
            {isTherapistsLoading ? <SimpleLoader /> : "Book Now"}
          </SearchFormTreatmentsButton>
          <SearchFormTreatmentsTooltipWrapper>
            <TooltipPopoverContainer
              text={tooltipText}
              isShow={isShowTooltip}
            />
          </SearchFormTreatmentsTooltipWrapper>
        </React.Fragment>
      )}
    </SearchForm>
  );
};

export { SearchFormTreatments };
